const COMBO_DISPLAY_THRESHOLD = 3;

export class Hud {
  private readonly cleanlinessValue = this.getElement('#cleanliness-value');
  private readonly progressValue = this.getElement('#progress-value');
  private readonly tierLabel = this.getElement('#tier-label');
  private readonly comboBadge = this.getElement('#combo-badge');

  update(cleanliness: number, answered: number, total: number, tierLabel: string, streak = 0): void {
    this.cleanlinessValue.textContent = String(Math.round(cleanliness));
    this.progressValue.textContent = `${answered}/${total}`;
    this.tierLabel.textContent = tierLabel;

    if (streak >= COMBO_DISPLAY_THRESHOLD) {
      this.comboBadge.textContent = `🔥 콤보 x${streak}`;
      this.comboBadge.hidden = false;
    } else {
      this.comboBadge.hidden = true;
    }
  }

  private getElement(selector: string): HTMLElement {
    const element = document.querySelector<HTMLElement>(selector);
    if (!element) throw new Error(`Missing HUD element: ${selector}`);
    return element;
  }
}
